import React, { useEffect, useState } from 'react';
import '../../Checkout.css';

const PaymentMethodAccordion = ({ payments, paymentMethodList, disabled, onChangePaymentMethod, inputPaymentsData }) => {
    const [togglePaymentMethodList, setTogglePaymentMethodList] = useState([]);
    const [firstLoad, setFirstLoad] = useState();
    useEffect(() => {
        let payments = [];
        let inputPaymentsDataVar = inputPaymentsData;
        for (var i = 0; i < paymentMethodList.length; i++) {
            const found = paymentMethodList[i].options.some(r => inputPaymentsDataVar.indexOf(r.value) >= 0);
            payments = [...payments, found];
        }
        setTogglePaymentMethodList(payments);
        if ((inputPaymentsData && inputPaymentsData.length > 0)) {
            setFirstLoad(false);
        }
        else {
            setFirstLoad(true);
        }
    }, [])

    const onClickToggleAccordion = (index) => {
        let paymentsToggleArr = togglePaymentMethodList;
        paymentsToggleArr[index] = !paymentsToggleArr[index];
        setTogglePaymentMethodList(prevArr => [...prevArr, paymentsToggleArr[index]]);
        setFirstLoad(false);
    }

    const handlePaymentsChange = (e) => {
        const { value } = e.currentTarget;
        if (e.target.checked) {
            inputPaymentsData = inputPaymentsData.includes(value) ? inputPaymentsData : [...inputPaymentsData, value];
        }
        else {
            inputPaymentsData = inputPaymentsData.includes(value) ? inputPaymentsData.filter(val => val !== value) : inputPaymentsData;
        }
        onChangePaymentMethod(inputPaymentsData, e);
    };

    return (
        <div className="accordion form-control" id="payments">
            {paymentMethodList.map(({ title, options, id }, index) => (
                <div className="accordion-item" key={id}>
                    <div className={`accordion-title ${disabled ? "disabled" : ""}`} onClick={disabled ? undefined : () => onClickToggleAccordion(index)}>
                        <span className={`accordionIcon ${firstLoad ? ((!togglePaymentMethodList[index]) ? "accordionMinus" : "accordionPlus") : ((togglePaymentMethodList[index]) ? "accordionMinus" : "accordionPlus")}`}></span>
                        <span className="accordion-label">{title}</span>
                    </div>
                    <div className={`accordion-content ${firstLoad ? ((!togglePaymentMethodList[index]) ? "open" : "") : (((togglePaymentMethodList[index]) ? "open" : ""))}`}>{options.map(({ title, value, id }) => (
                        <label htmlFor={id} className={`checkboxContainer ${disabled ? "disabled" : ""}`} key={id}>{title}
                            <input type="checkbox" name={id} id={id} value={value} className="accordionCheckBox"
                                defaultChecked={inputPaymentsData.includes(value)} disabled={disabled} onChange={(e) => {
                                    e.persist = () => { }
                                    handlePaymentsChange(e);
                                }} />
                            <span className="checkmark"></span>
                        </label>
                    ))
                    }
                    </div>
                </div>
            ))
            }
        </div>
    );
};

export default PaymentMethodAccordion;